import Vue from 'vue'
import { capitalize, numFormatter, timeFormatter } from '.';

export default (): void => {
  Vue.filter('numberSymbol', numFormatter)
  Vue.filter('timeSymbol', timeFormatter)
  Vue.filter('capitalize', capitalize)
}
